import * as React from 'react'
import Container from '@mui/material/Container';
import GlobalStyles from "@mui/material/GlobalStyles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack/Stack";
import Button from "@mui/material/Button/Button";
import {useLocation, useNavigate,} from "react-router-dom";

import {AuthUserContext} from "../../providers/AuthProvider";
import ScrollToTop from '../../utils/scrollTop';
function MemberShipPayment() {
    const {  profile } = React.useContext(AuthUserContext);
    const navigator = useNavigate();
    const loaction = useLocation();
    const {pack} = loaction.state
    return (
    <React.Fragment>
        <ScrollToTop/>
        <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
        <Container maxWidth="fullWidth" sx={{backgroundColor: '#E3E8F0', paddingY: 8,  mb: 8, textAlign:'left'}}>
            <Container maxWidth="lg">
            <Typography variant={'h4'} sx={{pl: 2}} color={'primary'}>
                Monthly subscription payment
            </Typography>
            </Container>
        </Container>
        <Container maxWidth="lg" sx={{}}>
            <Paper elevation={8}>
              <Box maxwidth="lg" sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'start',
                alignItems: 'start',
                height:"122px"
              }}>
                <Grid item xs={12} sx={{backgroundColor:"#204488",position:"relative",left:10,top:30}}>
                 <img src={`/assets/packages/${pack?.img}.png`} height={'48px'}  />
                </Grid>
                <Grid container>
                     

                    <Grid item xs={12}>
                        <Typography textAlign="left" sx={{color:"#363636",fontWeight:"700",fontSize:"24px",ml:10,marginTop:"-3%"}}>
                            {pack?.title}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography textAlign="left" sx={{color:"#363636",fontWeight:"400",fontSize:"16px",ml:10,}}>
                            {pack?.title === 'TAOST BASIC' ? 'Silver membership monthly payment' : 'Gold membership monthly payment'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography textAlign="right" sx={{color:"#363636",fontWeight:"700",fontSize:"24px",mr:6,marginTop:"-3%"}}>
                            $0/Mo
                        </Typography>
                    </Grid>
                 </Grid>
              </Box>
           </Paper>
        </Container>
        <Container sx={{ mt:10,borderBottom: '1px solid #204488'}}></Container>
        <Container maxWidth="lg">

            <Grid container spacing={2}  >
                <Grid item xs={12}>
                    <Typography textAlign="left" sx={{color:"#363636",fontWeight:"700",fontSize:"24px",mt:5}}>
                    Total
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography textAlign="right" sx={{color:"#363636",fontWeight:"700",fontSize:"24px",marginTop:'-4.54%'}}>
                        $0
                    </Typography>
                </Grid>
            </Grid>
            
                <Container maxWidth="lg" alignItems="center" justifyContent="center">
                    <Stack spacing={10} direction="row" sx={{
                        display: 'flex',
                        alignItems:"center",
                        justifyContent:"center",
                        mt:5,
                        mb:5
                    }}>
                        <Button variant="outlined" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,width:"180px"}}   onClick={() => navigator(-1)}>Go back</Button>
                        <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,width:"180px"}} type='submit' onClick={() =>{if(profile.userType === 'creator'){
                           navigator('/creator/additional-details')
                        }else if(profile.userType === 'investor'){
                            navigator('/investor/additional-details')
                        }else{ navigator('/artists/additional-details')}
                            // navigator('/artists/additional-details')

                        }}>Next</Button>
                    </Stack>
                </Container>

        </Container>
           
    </React.Fragment>
)
}  


export default MemberShipPayment